
(function () {
window.onpageshow = function (evt) {
    if (evt.persisted) window.location.reload();
};
})();



// ---- define (or reuse) the custom element ----
class JollySubscriptionOnetime extends HTMLElement {
constructor() {
    super();
    this._bound = false; // ensure we only wire once
}

connectedCallback() {
    if (this._bound) return;
    this._bound = true;

    this.elements = {
    subscriptionPurchase: document.querySelector('#subscription_purchase'),
    onetimePurchase: document.querySelector('#onetime_purchase'),
    subscriptionBlock: document.querySelector('#subscription_block'),
    onetimeBlock: document.querySelector('#onetime_block'),
    weightButtons: document.querySelectorAll('.jolly-btn-weight'),
    dataProductObj: '',
    jollyPlanInputs: document.querySelectorAll('.jolly-plan-input'),
    quantityInput: document.querySelector('input[name="quantity"]'),
    buyButtonText: document.querySelector('.jolly-buy-btn-text'),
    saveMessageMoneySpan: document.querySelector('.jolly-save-message-money'),
    buyForm: document.querySelector('.jolly-buy-form'),
    buyButton: document.querySelector('.jolly-buy-form button[type="submit"], .jolly-buy-form .btn-addtocart'),
    loadingIcon: document.querySelector('.jolly-loading-icon'),
    };

    this._wireUI();
    this.init();
    this._postInit();
}

// --- split wiring to avoid repeating ---
_wireUI() {
    const els = this.elements;

    // safety guards
    if (!els.subscriptionPurchase || !els.onetimePurchase) return;

    els.onetimePurchase.addEventListener('click', () => {
    this.switchBlock(els.subscriptionBlock, els.onetimeBlock);
    this.init();
    });

    els.jollyPlanInputs.forEach((input) => {
    input.addEventListener('click', () => {
        this.planInputsClick(input);
        this.setQuantity(input);
        this.setButtonText(input);
        this.setSaveMoneyMessageMoney(input);
    });
    });

    els.subscriptionPurchase.addEventListener('click', () => {
    this.switchBlock(els.onetimeBlock, els.subscriptionBlock);
    this.init();
    });

    els.weightButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
        this.switchBlockWeight(btn);
    });
    });

    this.syncPlanAvailability();
    this.onloadReset();
}

_postInit() {
    if (this.elements.loadingIcon) this.elements.loadingIcon.style.display = 'none';
    if (this.elements.buyForm) this.elements.buyForm.classList.add('jolly-loaded');
    this.classList.add('jolly-loaded');
}

onloadReset() {
    const subBlock = this.elements.subscriptionBlock;
    if (!subBlock || !this.elements.subscriptionPurchase) return;

    // Clicks only if elements exist
    this.elements.subscriptionPurchase.click();
    subBlock.querySelector('.jolly-btn-weight')?.click();
    subBlock.querySelector('.jolly-plan-input')?.click();
}

init() {
    const els = this.elements;
    if (!els) return;

    if (els.subscriptionPurchase?.checked) {
    let idx, activeWeightEl;
    document.querySelectorAll('.jolly-weight-input-subscription').forEach((el) => {
        if (el.checked) {
        idx = el.dataset.jollyIndex;
        activeWeightEl = el;
        }
    });
    if (!activeWeightEl) return;

    const plansWrap = activeWeightEl.closest('.jolly-block')
        ?.querySelector(`[data-plan-index^="${idx}"]`);
    if (!plansWrap) return;

    const currentPlan = this.getCurrentPlanIndex(plansWrap);
    if (!currentPlan) {
        this.clearSellingPlan();
        this.setSubscriptionSubmitDisabled(true);
        return;
    }

    this.setQuantity(currentPlan);
    this.setButtonText(currentPlan);
    this.setSellingPlan(currentPlan);
    this.setSubscriptionSubmitDisabled(false);

    } else if (els.onetimePurchase?.checked) {
    let idx, activeWeightEl;
    document.querySelectorAll('.jolly-weight-input-onetime').forEach((el) => {
        if (el.checked) {
        idx = el.dataset.jollyIndex;
        activeWeightEl = el;
        }
    });
    if (!activeWeightEl) return;

    const plansWrap = activeWeightEl.closest('.jolly-block')
        ?.querySelector(`[data-plan-index^="${idx}"]`);
    if (!plansWrap) return;

    const currentPlan = this.getCurrentPlanIndex(plansWrap);
    if (!currentPlan) return;

    this.setQuantity(currentPlan);
    this.setButtonText(currentPlan);
    this.setSaveMoneyMessageMoney(currentPlan);
    this.clearSellingPlan();
    this.setSubscriptionSubmitDisabled(false);
    }
}

switchBlock(hideEl, showEl) {
    hideEl?.classList.add('jc-hidden');
    showEl?.classList.remove('jc-hidden');
}

planInputsClick(inputEl) {
    if (inputEl.closest('.jolly-block')?.id !== 'subscription_block') return;
    this.setSellingPlan(inputEl);
}

setQuantity(planInputEl) {
    const qty = planInputEl?.dataset?.jollyQuantity;
    if (qty && this.elements.quantityInput) this.elements.quantityInput.value = qty;
}

setButtonText(planInputEl) {
    const txt = planInputEl?.dataset?.jollyButtonText;
    if (txt && this.elements.buyButtonText) this.elements.buyButtonText.innerHTML = txt;
}

setSaveMoneyMessageMoney(planInputEl) {
    const msg = planInputEl?.dataset?.jollySaveMessageMoney;
    if (msg && this.elements.saveMessageMoneySpan) {
    this.elements.saveMessageMoneySpan.innerHTML = msg;
    }
}

switchBlockWeight(weightBtn) {
    const block = weightBtn.closest('.jolly-block');
    const idx = weightBtn.dataset.jollyIndex;
    if (!block || !idx) return;

    const allPlanGroups = block.querySelectorAll('[data-plan-index]');
    const targetPlansWrap = block.querySelector(`[data-plan-index^="${idx}"]`);
    if (!targetPlansWrap) return;

    const currentPlan = this.getCurrentPlanIndex(targetPlansWrap);
    if (!currentPlan) {
    if (block.id === 'subscription_block') {
        this.clearSellingPlan();
        this.setSubscriptionSubmitDisabled(true);
    }
    return;
    }

    this.setQuantity(currentPlan);
    this.setButtonText(currentPlan);
    this.setSaveMoneyMessageMoney(currentPlan);

    allPlanGroups.forEach((grp) => grp.classList.add('jc-hidden'));
    targetPlansWrap.classList.remove('jc-hidden');

    if (block.id === 'subscription_block') {
    this.setSellingPlan(this.getCurrentPlanIndex(targetPlansWrap));
    this.setSubscriptionSubmitDisabled(false);
    }
}

getCurrentPlanIndex(plansWrap) {
    let active = null;
    plansWrap?.querySelectorAll('.jolly-plan-input')?.forEach((el) => {
    if (el.checked && !el.disabled) active = el;
    });
    if (!active) {
    active = plansWrap?.querySelector('.jolly-plan-input:not(:disabled)') || null;
    if (active) active.checked = true;
    }
    return active;
}

getProductForm() {
    return this.elements.buyForm?.querySelector('form[action*="/cart/add"]')
    || document.querySelector('.jolly-buy-form form[action*="/cart/add"]')
    || document.querySelector('form[action*="/cart/add"]');
}

getSellingPlanInput() {
    const form = this.getProductForm();
    if (!form) return null;

    let input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'selling_plan';
    form.appendChild(input);
    }
    return input;
}

setSellingPlan(planInputEl) {
    const sellingPlanId = planInputEl?.dataset?.skioSellingPlanId || '';
    if (!sellingPlanId || planInputEl?.disabled) return false;

    const input = this.getSellingPlanInput();
    if (input) input.value = sellingPlanId;
    return true;
}

clearSellingPlan() {
    const form = this.getProductForm();
    const input = form?.querySelector('input[name="selling_plan"]');
    if (input) input.value = '';
}

setSubscriptionSubmitDisabled(disabled) {
    const button = this.elements.buyButton;
    if (!button) return;

    if (disabled) {
    button.dataset.jollyMissingSellingPlan = 'true';
    button.disabled = true;
    return;
    }

    if (button.dataset.jollyMissingSellingPlan === 'true') {
    button.disabled = false;
    delete button.dataset.jollyMissingSellingPlan;
    }
}

syncPlanAvailability() {
    this.elements.subscriptionBlock?.querySelectorAll('.jolly-plan-input').forEach((input) => {
    const hasSellingPlan = Boolean(input.dataset.skioSellingPlanId);
    input.disabled = !hasSellingPlan;

    const label = document.querySelector(`label[for="${input.id}"]`);
    if (label) {
        label.setAttribute('aria-disabled', hasSellingPlan ? 'false' : 'true');
        if (!hasSellingPlan) label.setAttribute('title', 'Missing Skio selling plan ID');
        else label.removeAttribute('title');
    }
    });
}
}

// Define once, but ALWAYS create/upgrade instances already in DOM.
if (!customElements.get('jolly-subscription-onetime')) {
customElements.define('jolly-subscription-onetime', JollySubscriptionOnetime);
}

window.addEventListener('DOMContentLoaded', function () {
// Ensure an instance exists so connectedCallback runs.
if (!document.querySelector('jolly-subscription-onetime')) {
    document.body.appendChild(document.createElement('jolly-subscription-onetime'));
}
});
